import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44ba067f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "shadow-md ml-4 my-2 p-1 flex rounded-full border-2 border-gray-500 dark:border-dark-text-dark dark:text-dark-text-dark cursor-pointer hover:bg-gray-200 hover:dark:bg-dark",
  style: {"transition":"background-color 0.5s"}
}
const _hoisted_2 = {
  class: "material-icons",
  style: {"margin-left":"0.25px","margin-right":"0.25px"}
}
const _hoisted_3 = { class: "absolute bottom-full mb-2 drop-card" }
const _hoisted_4 = { class: "flex my-3" }
const _hoisted_5 = { class: "text-sm my-auto ml-2 whitespace-nowrap" }
const _hoisted_6 = { class: "flex my-3 relative" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons p-2 rounded-full bg-primary shadow-md hover:bg-primary-600 active:bg-primary-700 text-white cursor-pointer transition-colors duration-200",
  style: {"margin-left":"0.25px","margin-right":"0.25px"}
}, " upload ", -1))
const _hoisted_9 = { class: "text-sm my-auto ml-2 whitespace-nowrap" }
const _hoisted_10 = { class: "flex my-3" }
const _hoisted_11 = { class: "text-sm my-auto ml-2 whitespace-nowrap" }
const _hoisted_12 = { class: "flex my-3" }
const _hoisted_13 = { class: "text-sm my-auto ml-2 whitespace-nowrap" }
const _hoisted_14 = { class: "flex my-3" }
const _hoisted_15 = { class: "text-sm my-auto ml-2 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative select-none",
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nested.hide.value = true)),
    onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nested.hide.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.titleIcon), 1)
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer",
                style: {"margin-left":"0.25px","margin-right":"0.25px","transition":"background-color 0.5s"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeFreeSpaceMode && _ctx.changeFreeSpaceMode(...args)))
              }, " space_dashboard "),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.freeSpace')), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('message.upload')), 1)
              ]),
              _createElementVNode("input", {
                class: "hidden",
                type: "file",
                onChange: _cache[1] || (_cache[1] = event => _ctx.editorPageStatePresenter.uploadSourceCode(event as InputEvent))
              }, null, 32)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: "material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer",
                style: {"margin-left":"0.25px","margin-right":"0.25px","transition":"background-color 0.5s"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editorPageStatePresenter.downloadSourceCode && _ctx.editorPageStatePresenter.downloadSourceCode(...args)))
              }, " download "),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('message.download')), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer",
                style: {"margin-left":"0.25px","margin-right":"0.25px","transition":"background-color 0.5s"},
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.increaseFontSize && _ctx.increaseFontSize(...args)))
              }, " add "),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('message.zoomIn')), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                class: "material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer",
                style: {"margin-left":"0.25px","margin-right":"0.25px","transition":"background-color 0.5s"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.decreaseFontSize && _ctx.decreaseFontSize(...args)))
              }, " remove "),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('message.zoomOut')), 1)
            ])
          ])
        ], 512), [
          [_vShow, !_ctx.nested.hide.value]
        ])
      ]),
      _: 1
    })
  ], 32))
}